<template>
    <div class="col-lg-9">
        <div class="d-flex align-items-center mb-2">
            <h4 class="text-7">Stored Account</h4>
            <router-link
                :to="`/business/stored-accounts/add`"
                class="btn btn-success btn-sm text-white shadow-none ml-auto"
            >
                <i class="fas fa-plus-circle mr-2"></i>Add Account
            </router-link>
        </div>
        <div class="custom-nav-container mb-3">
            <ul class="custom-nav-tabs">
                <li class="custom-nav-item">
                    <router-link class="custom-nav-link"
                                 :to="`/business/stored-accounts`"
                    > All Accounts
                    </router-link>
                </li>
                <li class="custom-nav-item">
                    <router-link class="custom-nav-link"
                                 :class="{ active: $route.path.includes('/edit') }"
                                 :to="`/business/stored-accounts/${$route.params.id || ''}/edit`">
                        Update Account
                    </router-link>
                </li>
            </ul>

            <div class="custom-nav-underline">
                <div class="custom-nav-active-underline"
                     :style="{ left: activeTabPosition, width: activeTabWidth }">
                </div>
            </div>
        </div>

        <keep-alive>
            <transition name="slide-in-left">
                <router-view></router-view>
            </transition>
        </keep-alive>
    </div>
</template>

<script>
export default {
    name: "Index",
    props:["permissions"],
    data() {
        return {
            activeTabPosition: "0px",
            activeTabWidth: "0px",
        };
    },
    methods: {
        updateActiveTabPosition() {
            this.$nextTick(() => {
                const activeTab = document.querySelector(".custom-nav-tabs .custom-nav-link.active");
                if (activeTab) {
                    this.activeTabPosition = `${activeTab.offsetLeft}px`;
                    this.activeTabWidth = `${activeTab.offsetWidth}px`;
                }
            });
        }
    },
    mounted() {
        this.updateActiveTabPosition();
    },
    watch: {
        "$route.path": function () {
            this.updateActiveTabPosition();
        }
    }
}
</script>
